import service from "@/store/services/contacts-service";

export const state = () => ({
  list: {},
  contact: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, contact) => {
    if (contact.contactable == null) {
      contact.contactable = {};
    }
    state.contact = contact;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((contact) => {
      commit("SET_RESOURCE", contact);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((contact) => {
      commit("SET_RESOURCE", contact);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((contact) => {
      commit("SET_RESOURCE", contact);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  contact: (state) => state.contact,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((contact) => ({
      id: contact.id,
      name: `${contact.firstname} ${contact.lastname}`,
    }));
  },
};

const contacts = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default contacts;
